<!--
    描述：标签管理 --- 标签汇总
    时间：2021-01-15
    Created by ws
-->
<template>
	<!-- 主页面 -->
	<div class="operation-layout" :class="{ pd0: !routeQuery }">
		<!-- 列表查询页 -->
		<filter-layout @search="doSearch" @reset="doRefresh" v-if="!routeQuery">
			<template #filter>
				<el-form class="flex-row-form colspan-4" size="small" ref="searchRef" :model="searchForm" label-width="120px">
					<el-form-item label="业务板块：" prop="busUnit">
						<el-select v-model="searchForm.busUnit" placeholder="请选择业务板块">
							<el-option v-for="(item, index) in systemArr" :key="'yewu' + index" :label="item.label" :value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="标签对象：" prop="value">
						<el-select v-model="searchForm.value">
							<el-option v-for="(item, index) in tagsArr" :key="'TAG' + index" :label="item.label" :value="item.value"></el-option>
						</el-select>
					</el-form-item>
				</el-form>
			</template>
			<template #content>
				<!-- 非请求参数 正常查看 -->
				<div class="operation-main">
					<div class="operation-header">
						<div class="title">
							合计标签<span class="blue"> {{ tableObj.total }}</span> 个
						</div>
						<div class="btnGroups"></div>
					</div>
					<div class="operation-container w-table-layout w-table-page">
						<div class="w-table-content" v-show="tableShow">
							<vxe-table
								ref="xTable"
								:data="tableObj.tableData"
								highlight-current-row
								highlight-hover-row
								size="small"
								align="center"
								border
								height="100%"
								auto-resize
								resizable
								show-overflow="tooltip"
								show-header-overflow="tooltip"
							>
								<vxe-table-column type="seq" title="序号" width="55px"></vxe-table-column>
								<vxe-table-column field="valueName" title="标签对象" min-width="185px"></vxe-table-column>
								<vxe-table-column field="busUnitName" title="业务板块" min-width="185px"></vxe-table-column>
								<vxe-table-column
									field="platformCountsName"
									title="平台标签数量"
									header-align="center"
									align="right"
									width="160px"
								></vxe-table-column>
								<vxe-table-column
									field="privateCountsName"
									title="个人标签数量"
									header-align="center"
									align="right"
									width="160px"
								></vxe-table-column>
								<vxe-table-column field="typeCountsName" title="标签标注记录数量" width="165px" header-align="center" align="right">
								</vxe-table-column>
								<vxe-table-column field="objectCountsName" title="标签标注数量" width="165px" header-align="center" align="right">
								</vxe-table-column>
								<vxe-table-column title="操作" width="8%">
									<template v-slot="{ row }">
										<el-button
											class="table-btn"
											type="primary"
											size="small"
											round
											plain
											v-if="roleBtns.includes('detail')"
											@click="doView(row)"
										>
											<svg-icon icon-class="form-details"></svg-icon> 详情
										</el-button>
									</template>
								</vxe-table-column>
							</vxe-table>
						</div>
						<div class="w-table-footer">
							<el-pagination
								@size-change="handleSizeChange"
								@current-change="handleCurrentChange"
								:current-page="tableObj.currentPage"
								:page-size="tableObj.pageSize"
								:page-sizes="[10, 20, 50, 100]"
								layout="total, sizes, prev, pager, next, jumper"
								:total="tableObj.total"
							>
							</el-pagination>
						</div>
					</div>
				</div>
			</template>
		</filter-layout>

		<!-- 详细页面 -->
		<template v-else>
			<summary-detail :allList="tableObj.tableData"></summary-detail>
		</template>
	</div>
</template>

<script>
import summaryDetail from './tag_summary_detail'
import { mapState } from 'vuex'

import { getDict, getAllTag } from 'api/modules/tag_management'
export default {
	components: {
		summaryDetail
	},
	data() {
		return {
			searchToggle: true, // 切换展示 筛选条件
			tableShow: true, // 展示表格
			// 查询条件
			searchForm: {
				busUnit: '', // 业务板块
				value: '' // 标签对象
			},
			// 表格参数
			tableObj: {
				tableData: [],
				currentPage: 1,
				pageSize: 10,
				total: 0
			},
			// 码表数组
			systemArr: [], // 业务板块
			tagsArr: [] // 标签对象
		}
	},
	created() {
		// 如果是 返回的
		if (this.isBack) {
			if (this.$getSessionItem('tag')) {
				this.searchForm = JSON.parse(this.$getSessionItem('tag'))
				this.tableObj.currentPage = JSON.parse(this.$getSessionItem('tag')).currentPage
				this.tableObj.pageSize = JSON.parse(this.$getSessionItem('tag')).pageSize
				this.$removeSessionItem('tag')
			}
		}

		this.getDictList()
		this.doSearch()
	},
	methods: {
		// 获取码表
		getDictList() {
			getDict({ value: '1001025' })
				.then((res) => {
					if (res.operationCode === 1) {
						this.systemArr = res.data
					}
				})
				.catch((err) => {})
		},

		// 查询
		doSearch() {
			let params = {
				current: this.tableObj.currentPage,
				size: this.tableObj.pageSize,
				busUnit: this.searchForm.busUnit, // 业务板块码表值
				value: this.searchForm.value // 标签对象码表值
			}
			getAllTag(params)
				.then((res) => {
					if (res.operationCode === 1) {
						this.tableObj.tableData = res.data.records
						this.tableObj.total = parseInt(res.data.total)
					}
				})
				.catch((err) => {})
		},

		// 点击刷新、重置
		doRefresh() {
			this.tableObj.currentPage = 1
			this.tableObj.pageSize = 10
			this.searchForm.busUnit = ''
			this.searchForm.value = ''
			// this.$refs.searchRef.resetFields();
			this.doSearch()
		},

		// 点击查看
		doView(row) {
			let params = Object.assign({}, this.searchForm)
			params.pageSize = this.tableObj.pageSize
			params.currentPage = this.tableObj.currentPage

			// 存值
			this.$setSessionItem('tag', JSON.stringify(params))
			this.$router.push({
				query: {
					type: 'detail',
					rowId: row.id,
					busUnit: row.busUnit,
					applys: row.value
				}
			})
		},

		// 表格 每页条数切换
		handleSizeChange(size) {
			this.tableObj.pageSize = size
			this.doSearch()
		},

		// 表格 页码切换
		handleCurrentChange(cur) {
			this.tableObj.currentPage = cur
			this.doSearch()
		}
	},
	computed: {
		// 路由参数
		routeQuery() {
			return this.$route.query.type
		},
		...mapState('menu', {
			roleBtns: (state) => state.roleBtns
		}),
		...mapState('app', {
			isBack: (state) => state.isBack
		})
	},
	watch: {
		// 监听 筛选元素的 切换展示 重新调整表格高度
		searchToggle() {
			this.tableShow = false
			setTimeout(() => {
				this.tableShow = true
			}, 50)
		},

		// 业务板块
		'searchForm.busUnit': {
			handler: function(val) {
				// 清空选择
				this.searchForm.value = ''

				if (val && val !== '') {
					let _item = this.systemArr.find((x) => x.value === val)
					_item ? (this.tagsArr = _item.children) : []
				} else {
					this.tagsArr = []
				}
			},
			deep: true
		}
	}
}
</script>

<style scoped lang="less">
.operation-header {
	// justify-content: flex-end;
}
</style>
